import { useToastStore } from '../stores/toastStore';

interface ErrorLogEntry {
  time: string;
  type: 'js-error' | 'unhandledrejection' | 'api-error' | 'react-error';
  message: string;
  url?: string;
  stack?: string;
  details?: unknown;
}

const STORAGE_KEY = 'planet_error_logs';
const MAX_LOGS = 50;

export function getErrorLogs(): ErrorLogEntry[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function saveErrorLog(entry: ErrorLogEntry) {
  const logs = getErrorLogs();
  logs.push(entry);
  if (logs.length > MAX_LOGS) logs.splice(0, logs.length - MAX_LOGS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
}

export function logError(type: ErrorLogEntry['type'], message: string, details?: unknown) {
  const entry: ErrorLogEntry = {
    time: new Date().toISOString(),
    type,
    message,
    url: window.location.href,
    details,
  };
  saveErrorLog(entry);
  console.error(`[${type}]`, message, details);
}

export function initGlobalErrorHandlers() {
  // Capture JS runtime errors
  window.addEventListener('error', (event) => {
    logError('js-error', event.message, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
    });
  });

  // Capture unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    logError('unhandledrejection', message, {
      stack: reason instanceof Error ? reason.stack : undefined,
    });

    // Show toast for unhandled API errors
    if (typeof reason === 'object' && reason?.config?.url) {
      const toast = useToastStore.getState().addToast;
      toast(`Network error: ${message}`, 'error', 5000);
    }
  });
}
